<p class="maxx-slack__description body-13-regular">The Slack channel where your team works with MAXX</p>

@if (isLoading()) {
  <p class="maxx-slack__muted body-13-regular">Loading…</p>
} @else if (loadFailed()) {
  <p class="maxx-slack__error body-13-regular">Could not load Slack settings. Please try again.</p>
} @else if (isEditing()) {
  <div class="maxx-slack__form">
    <ol class="maxx-slack__steps body-13-regular">
      <li>In Slack, type <code>/invite &#64;MAXX</code> in your channel.</li>
      <li>Paste the channel ID below. You can find it in Slack under the channel name → About.</li>
    </ol>
    <span class="body-14-medium">Channel ID</span>
    <div class="maxx-slack__input-row">
      <pdq-input
        class="maxx-slack__input"
        [control]="channelIdControl"
        placeholder="C0123456789"
        [maxLength]="32"
        (onEnter)="check()"></pdq-input>
      <pdq-button
        variant="light"
        size="small"
        label="Check"
        [loading]="isChecking()"
        [disabled]="!channelIdControl.value?.trim() || isChecking()"
        (onClick)="check()"></pdq-button>
    </div>
    @if (errorMessage()) {
      <p class="maxx-slack__error body-13-regular">{{ errorMessage() }}</p>
    }
    @if (checkedChannel(); as channel) {
      <div class="maxx-slack__found">
        <span class="body-14-regular">#{{ channel.name }}</span>
        <pdq-button
          variant="primary"
          size="small"
          label="Connect"
          [loading]="isConnecting()"
          [disabled]="isConnecting()"
          (onClick)="connect()"></pdq-button>
      </div>
    }
  </div>
} @else if (connectedChannel()) {
  <div class="maxx-slack__row">
    <div class="maxx-slack__row-text">
      <span class="body-14-medium">Channel</span>
      <span class="body-14-regular">#{{ connectedChannel()?.name }}</span>
    </div>
    <div class="maxx-slack__row-actions">
      <pdq-button
        variant="danger"
        size="small"
        label="Disconnect"
        [loading]="isDisconnecting()"
        [disabled]="isDisconnecting()"
        (onClick)="disconnect()"></pdq-button>
    </div>
  </div>
  @if (errorMessage()) {
    <p class="maxx-slack__error body-13-regular">{{ errorMessage() }}</p>
  }
} @else {
  <div class="maxx-slack__empty">
    <span class="body-14-medium">Slack isn’t connected yet</span>
    <span class="maxx-slack__muted body-13-regular">Connect Slack to work with MAXX in your team’s channel.</span>
    <div class="maxx-slack__action">
      <pdq-button variant="primary" size="small" label="Connect Slack" (onClick)="startEditing()"></pdq-button>
    </div>
  </div>
}
